/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { LoginResponse } from '../../models/login-response';
import { MyselfUpdateDto } from '../../models/myself-update-dto';

export interface IdentityControllerUpdateMyself$Params {
      body: MyselfUpdateDto
}

export function identityControllerUpdateMyself(http: HttpClient, rootUrl: string, params: IdentityControllerUpdateMyself$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LoginResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerUpdateMyself.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: LoginResponse;
      }>;
    })
  );
}

identityControllerUpdateMyself.PATH = '/identity/myself';
